import fonts from '@helpers/fonts';
import brand from '@helpers/brand';
import styled from 'styled-components';
const Grid = styled.div `
  margin-bottom: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
`;
const Container = styled.a `
  text-decoration: none;
  color: white;

  &[data-variant="inline"] {
    display: flex;
    align-items: center;
    gap: 12px;

    ${Grid} {
      margin-bottom: 0;
    }
  }

  &[data-theme='dark'] {
    color: ${brand.white};
  }

  &[data-theme='light'] {
    color: ${brand.black};

    svg g {
      fill: ${brand.black};
    }
  }  
`;
const StarContainer = styled.div `
  display: flex;
  gap: 4px;

  svg {
    width: 20px;
    height: 20px;
    color: ${brand.yellow};
  }
`;
const RatingText = styled.div `
  font-size: 16px;
  ${fonts.altGothicNo2.regular};
`;
const TextContainer = styled.div `
  display: flex;
  gap: 5px;
  align-items: center;

  svg {
    width: 100px;
  }
`;
const HomepageTextContainer = styled(TextContainer) `
  svg {
    transform: translateY(3px);
  }
`;
const Text = styled.p `
  ${fonts.altGothicNo2.regular};
  margin-bottom: 0;
  font-size: 16px;
  opacity: 0.8;
  text-wrap: pretty;
  white-space: nowrap;
`;
const ReviewScoreStyles = {
    Container,
    Grid,
    TextContainer,
    Text,
    RatingText,
    StarContainer,
    HomepageTextContainer
};
export default ReviewScoreStyles;
